import * as t from "io-ts";
import { cargoTypeT } from "./types";
export const driverCargoTypesT = t.strict({
    cargoTypes: t.array(cargoTypeT)
});
//# sourceMappingURL=driver-cargo-types.js.map